import { z } from 'zod';

export const AnswerModel = z.object({
  answer: z.string(),
  is_correct: z.boolean().optional(),
  id: z.number().optional(),
});

export const QuestionModel = z.object({
  id: z.number().optional(),
  question: z.string(),
  answers: AnswerModel.array(),
});

export const QuestionnaireModel = z.object({
  id: z.number(),
  questions: QuestionModel.array(),
});

export type DocumentAssessmentValidateInput = z.infer<
  typeof QuestionnaireModel
>;

export const WrongAnswerDetailedModel = z.object({
  message: z.string(),
  slug: z.literal('wrong-answers-detailed'),
  ids_of_questions_with_wrong_answers: z.number().array(),
});

export const WrongAnswerGenericModel = z.object({
  message: z.string(),
  slug: z.literal('wrong-answers-generic'),
  number_of_wrong_answers: z.number(),
});

export const ValidAnswersModel = z.object({
  message: z.string(),
  slug: z.literal('valid-answers'),
});

export const ValidAnswersWithWrongAnswersModel = z.object({
  message: z.string(),
  slug: z.literal('valid-answers-with-wrong-answers'),
  percentage_of_answers_correct: z.number(),
});

export const ErrorModel = z.object({
  message: z.string(),
  slug: z.literal('error'),
});

export const DocumentAssessmentValidateOutputModel = z.discriminatedUnion(
  'slug',
  [
    ValidAnswersModel,
    ValidAnswersWithWrongAnswersModel,
    WrongAnswerDetailedModel,
    WrongAnswerGenericModel,
    ErrorModel,
  ],
);

export type DocumentAssessmentValidateOutput = z.infer<
  typeof DocumentAssessmentValidateOutputModel
>;
